<mat-icon color="accent">{{ icon }}</mat-icon>
<nobr class="snackbarTextMessage" translate>{{ message }} <span>{{boardname}}</span></nobr>
